var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('nav',{staticClass:"nav-bar"},[_c('NavBar')],1),_c('div',{staticClass:"marginCenter"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }